import React, { useMemo } from "react";

import { Box } from "@mui/material";

import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { setIsAppLoading } from "../../redux/slices/app/app.slice";
import BusinessSelect from "../BusinessSelect";
import Burger from "./Burger";
import "./header.css";

const Header = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();

    const setAppLoader = () => {
        dispatch(setIsAppLoading(false));
        return false;
    };

    const shouldShowHeader = useMemo(() => {
        const parsedLocation = location.pathname.split("/"); // '', route, id
        const handlers = [
            {
                predicate: () =>
                    location.pathname.includes("create-landing-page") ||
                    location.pathname.includes("landing-pages/edit") ||
                    location.pathname.includes("landing-pages/clone") ||
                    location.pathname === "/wizard",
                handler: () => false,
            },
            {
                predicate: () => location.pathname === "/leads-wizard",
                handler: () => setAppLoader(),
            },
            {
                predicate: () => parsedLocation?.[1] === "tracker",
                handler: () => false,
            },
            {
                predicate: () => true,
                handler: () => true,
            },
        ];
        return handlers?.find(({ predicate }) => predicate())?.handler();
    }, [location.pathname]);

    return (
        shouldShowHeader && (
            <div className="new-header">
                <BusinessSelect fromRightNav={false} />
                <Box>
                    <Burger className="ml-4" />
                </Box>
            </div>
        )
    );
};

export default Header;
